import CustomButton from "@/components/CustomButton";
import { IS_PRODUCTION } from "@/constants/constants";
import { getHouseholdPrintFileName } from "@/helper/helper";
import { useAppSelector } from "@/hooks/useAppSelector";
import { useUPPrint } from "@/hooks/useUPPrint";
import { UniquePossibilities } from "@/types/types";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

type Props = {
  hasUPData: boolean;
  label: string;
  upData?: UniquePossibilities;
};

export default function PrintPreviewUPButton({ hasUPData, upData }: Props) {
  const { mutateAsync: downloadAsync, error: printErrorMsg, isPending } = useUPPrint();

  const {
    isModified: isUpModified,
    gridSet,
    settings,
    headerTitles: titles,
    showRoR,
    showSocialSecurity,
    showHiddenRows,
  } = useAppSelector((state) => state.uq);
  const household = upData?.household;

  const fileName = getHouseholdPrintFileName({
    clientCode: household?.clientCode as string,
    tabName: "Unique Possibilities Preview",
  });

  const toastMessages = {
    pending: "Downloading Preview of Unique Possibilities..",
    success: "Preview of Unique Possibilities downloaded!",
    error:
      printErrorMsg instanceof AxiosError
        ? printErrorMsg.message
        : "Downloading Preview of Unique Possibilities failed",
  };

  if (!isUpModified || IS_PRODUCTION) return null;

  return (
    <div>
      <CustomButton
        className="print:hidden"
        text={"Print Preview to PDF"}
        disabled={!hasUPData || isPending}
        onClickHandler={() => {
          toast.promise(
            downloadAsync({
              externalCode: household?.externalCode,
              clientCode: household?.clientCode,
              fileName,
              showRoR: showRoR,
              showSS: showSocialSecurity,
              showHiddenRows,
              upData: JSON.stringify({
                gridSet,
                settings,
                household,
                titles,
              }),
            }),
            toastMessages
          );
        }}
      />
    </div>
  );
}
